<template>
  <div v-if="upsell" class="cart_item_upsell" :class="{ _show: upsell.show, _animate_in: upsell.new }" ref="upsellItem">
    <button aria-label="Dismiss upsell" class="cart_item_upsell_close css_cross" @click.prevent="dismiss()"></button>
    <div class="cart_item_upsell_announcer">Get the set!</div>
    <div class="cart_item_upsell_content">
      <a :href="upsell.url" class="cart_item_upsell_image_col">
        <img class="_self_loading_image" :alt="`${upsell.title}`"  :class="{ _loaded: itemImageLoaded }" :src="utils.getSizedImageUrl(upsell.featured_image, '200x')" :style="{ background: utils.getSizedImageUrl(upsell.featured_image, '1x') }" @load="() => itemImageLoaded = true">
      </a>
      <div class="cart_item_upsell_details">
        <a :href="upsell.url">
          {{ upsell.title }}
        </a>
        <div>{{ $options.filters.withCurrency($options.filters.money(upsell.price)) }}</div>
        <div class="cart_item_upsell_buy_buttons">
          <button class="single_buy_button" v-for="variant in upsell.variants" @click.prevent="add(variant.id)" :disabled="!variant.available"><span>{{ variant.title }}</span></button>
        </div>
        <!--
        <div class="cart_item_upsell_buy_buttons">
          <button class="single_buy_button"><span>One Size</span></button>
        </div>
        <div class="cart_item_upsell_buy_buttons">
          <button class="single_buy_button"><span>XS/S</span></button>
          <button class="single_buy_button"><span>S/M</span></button>
          <button class="single_buy_button"><span>M/L</span></button>
        </div>
        <div class="cart_item_upsell_buy_buttons">
          <button class="single_buy_button"><span>XS/S</span></button>
          <button class="single_buy_button"><span>S/M</span></button>
          <button class="single_buy_button"><span>M/L</span></button>
          <button class="single_buy_button"><span>L/XL</span></button>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
  // To Do: Consider highlighting the size relevant to the originator
  // To Do: Consider migrating upsell decision mechanics to JS instead of Liquid, for more seamless changes/integration with personalisation suggestions.
  // Dismiss upsell using a line item property and a cookie - cookie for at the time, but line item property for future upsell fetches (since upsell calculation uses Liquid).
  export default {
    name: 'cart_item_upsell',
    props: ['upsell', 'originator'],
    data () {
      return {
        itemImageLoaded: false,
      }
    },
    computed: {
      upsellClosed: function() {
        const { item } = this;
        const { variant_id } = item;
        const cookieName = `${ variant_id }_closed`;
        return 
      },
    },
    methods: {
      add: function(id) {
        const { upsellItem } = this.$refs;
        upsellItem.classList.add('_loading');

      // Trigger Add to Cart GA4 Event
        if (typeof gtag === 'function') {
          gtag('event', 'sidecart_upsell_add', {
            'event_category': 'Upsell Interaction',
            'event_label': this.upsell.title,
            'event_action': 'click',
            'value': 1,
            'send_to': 'G-94HKVG42FB' 
          });
        }
        window.cartUtils.addOrChange(id, 1, { properties: { _complete_the_set: this.originator } });
      },
      dismiss: function(id) {
        const { upsellItem } = this.$refs;
        upsellItem.classList.add('_animate_out');

    //  Trigger Dismiss GA4 Event
      if (typeof gtag === 'function') {
        gtag('event', 'dismiss_sidecart_upsell', {
          'event_category': 'Upsell Interaction',
          'event_label': this.upsell.title,
          'event_action': 'click',
          'value': 1,
          'send_to': 'G-94HKVG42FB' 
        });
      }
        window.cartUtils.changeItem(this.originator, undefined, { properties: { _dismiss_set: true } });
      },
    },
  }
</script>




  